// source: proto/card.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.proto.Card', null, global);
goog.exportSymbol('proto.proto.CardFilter', null, global);
goog.exportSymbol('proto.proto.CardPagination', null, global);
goog.exportSymbol('proto.proto.CardSort', null, global);
goog.exportSymbol('proto.proto.CreateCardRequest', null, global);
goog.exportSymbol('proto.proto.CreateCardResponse', null, global);
goog.exportSymbol('proto.proto.DeleteCardRequest', null, global);
goog.exportSymbol('proto.proto.DeleteCardResponse', null, global);
goog.exportSymbol('proto.proto.ItemCardRequest', null, global);
goog.exportSymbol('proto.proto.ItemCardResponse', null, global);
goog.exportSymbol('proto.proto.ListCardRequest', null, global);
goog.exportSymbol('proto.proto.ListCardResponse', null, global);
goog.exportSymbol('proto.proto.UpdateCardRequest', null, global);
goog.exportSymbol('proto.proto.UpdateCardResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.Card = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.Card, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.Card.displayName = 'proto.proto.Card';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CardFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CardFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CardFilter.displayName = 'proto.proto.CardFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CardSort = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CardSort, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CardSort.displayName = 'proto.proto.CardSort';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CardPagination = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CardPagination, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CardPagination.displayName = 'proto.proto.CardPagination';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ListCardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ListCardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ListCardRequest.displayName = 'proto.proto.ListCardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ListCardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.ListCardResponse.repeatedFields_, null);
};
goog.inherits(proto.proto.ListCardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ListCardResponse.displayName = 'proto.proto.ListCardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ItemCardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ItemCardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ItemCardRequest.displayName = 'proto.proto.ItemCardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.ItemCardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.ItemCardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.ItemCardResponse.displayName = 'proto.proto.ItemCardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CreateCardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CreateCardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CreateCardRequest.displayName = 'proto.proto.CreateCardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.CreateCardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.CreateCardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.CreateCardResponse.displayName = 'proto.proto.CreateCardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.UpdateCardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.UpdateCardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.UpdateCardRequest.displayName = 'proto.proto.UpdateCardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.UpdateCardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.UpdateCardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.UpdateCardResponse.displayName = 'proto.proto.UpdateCardResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeleteCardRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DeleteCardRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeleteCardRequest.displayName = 'proto.proto.DeleteCardRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.DeleteCardResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.DeleteCardResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.DeleteCardResponse.displayName = 'proto.proto.DeleteCardResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.Card.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.Card.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.Card} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Card.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cardName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cardDesc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cardInfo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cardImg: jspb.Message.getFieldWithDefault(msg, 5, ""),
    cardPriority: jspb.Message.getFieldWithDefault(msg, 6, 0),
    cardPubliced: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    cardPromoted: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    typeId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    typeName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    categoryId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    categoryName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    cityId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    cityName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    sbeId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    sbeFullname: jspb.Message.getFieldWithDefault(msg, 16, ""),
    sbeName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    buttonText: jspb.Message.getFieldWithDefault(msg, 18, ""),
    offerUrl: jspb.Message.getFieldWithDefault(msg, 19, ""),
    promotedImg: jspb.Message.getFieldWithDefault(msg, 20, ""),
    dateFrom: (f = msg.getDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTill: (f = msg.getDateTill()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdDate: (f = msg.getCreatedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedDate: (f = msg.getUpdatedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    unlimDate: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    promotedDateFrom: (f = msg.getPromotedDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    promotedDateTill: (f = msg.getPromotedDateTill()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.Card}
 */
proto.proto.Card.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.Card;
  return proto.proto.Card.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.Card} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.Card}
 */
proto.proto.Card.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardDesc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardInfo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardImg(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardPriority(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCardPubliced(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCardPromoted(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTypeId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeName(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCategoryId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCityId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityName(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSbeId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeFullname(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setButtonText(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOfferUrl(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromotedImg(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateFrom(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTill(value);
      break;
    case 23:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedDate(value);
      break;
    case 24:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedDate(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnlimDate(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPromotedDateFrom(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPromotedDateTill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.Card.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.Card.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.Card} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.Card.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCardName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCardDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCardInfo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCardImg();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCardPriority();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCardPubliced();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCardPromoted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getTypeId();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getTypeName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCategoryId();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCategoryName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCityId();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getCityName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSbeId();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getSbeFullname();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSbeName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getButtonText();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOfferUrl();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getPromotedImg();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getDateFrom();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTill();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedDate();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedDate();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnlimDate();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getPromotedDateFrom();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPromotedDateTill();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 card_id = 1;
 * @return {number}
 */
proto.proto.Card.prototype.getCardId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string card_name = 2;
 * @return {string}
 */
proto.proto.Card.prototype.getCardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string card_desc = 3;
 * @return {string}
 */
proto.proto.Card.prototype.getCardDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string card_info = 4;
 * @return {string}
 */
proto.proto.Card.prototype.getCardInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string card_img = 5;
 * @return {string}
 */
proto.proto.Card.prototype.getCardImg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardImg = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 card_priority = 6;
 * @return {number}
 */
proto.proto.Card.prototype.getCardPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool card_publiced = 7;
 * @return {boolean}
 */
proto.proto.Card.prototype.getCardPubliced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardPubliced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool card_promoted = 8;
 * @return {boolean}
 */
proto.proto.Card.prototype.getCardPromoted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCardPromoted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 type_id = 9;
 * @return {number}
 */
proto.proto.Card.prototype.getTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string type_name = 10;
 * @return {string}
 */
proto.proto.Card.prototype.getTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 category_id = 11;
 * @return {number}
 */
proto.proto.Card.prototype.getCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string category_name = 12;
 * @return {string}
 */
proto.proto.Card.prototype.getCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 city_id = 13;
 * @return {number}
 */
proto.proto.Card.prototype.getCityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCityId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string city_name = 14;
 * @return {string}
 */
proto.proto.Card.prototype.getCityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setCityName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 sbe_id = 15;
 * @return {number}
 */
proto.proto.Card.prototype.getSbeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setSbeId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string sbe_fullname = 16;
 * @return {string}
 */
proto.proto.Card.prototype.getSbeFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setSbeFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string sbe_name = 17;
 * @return {string}
 */
proto.proto.Card.prototype.getSbeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setSbeName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string button_text = 18;
 * @return {string}
 */
proto.proto.Card.prototype.getButtonText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setButtonText = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string offer_url = 19;
 * @return {string}
 */
proto.proto.Card.prototype.getOfferUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setOfferUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string promoted_img = 20;
 * @return {string}
 */
proto.proto.Card.prototype.getPromotedImg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setPromotedImg = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional google.protobuf.Timestamp date_from = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.Card.prototype.getDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.Card} returns this
*/
proto.proto.Card.prototype.setDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.clearDateFrom = function() {
  return this.setDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Card.prototype.hasDateFrom = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.Timestamp date_till = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.Card.prototype.getDateTill = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.Card} returns this
*/
proto.proto.Card.prototype.setDateTill = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.clearDateTill = function() {
  return this.setDateTill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Card.prototype.hasDateTill = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Timestamp created_date = 23;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.Card.prototype.getCreatedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 23));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.Card} returns this
*/
proto.proto.Card.prototype.setCreatedDate = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.clearCreatedDate = function() {
  return this.setCreatedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Card.prototype.hasCreatedDate = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Timestamp updated_date = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.Card.prototype.getUpdatedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.Card} returns this
*/
proto.proto.Card.prototype.setUpdatedDate = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.clearUpdatedDate = function() {
  return this.setUpdatedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Card.prototype.hasUpdatedDate = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional bool unlim_date = 25;
 * @return {boolean}
 */
proto.proto.Card.prototype.getUnlimDate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.setUnlimDate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional google.protobuf.Timestamp promoted_date_from = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.Card.prototype.getPromotedDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.Card} returns this
*/
proto.proto.Card.prototype.setPromotedDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.clearPromotedDateFrom = function() {
  return this.setPromotedDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Card.prototype.hasPromotedDateFrom = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp promoted_date_till = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.Card.prototype.getPromotedDateTill = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.Card} returns this
*/
proto.proto.Card.prototype.setPromotedDateTill = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.Card} returns this
 */
proto.proto.Card.prototype.clearPromotedDateTill = function() {
  return this.setPromotedDateTill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.Card.prototype.hasPromotedDateTill = function() {
  return jspb.Message.getField(this, 27) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CardFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CardFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CardFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CardFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cardName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cardTypeName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    categoryName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cityName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sbeName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sbeFullname: jspb.Message.getFieldWithDefault(msg, 7, ""),
    cardPubliced: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CardFilter}
 */
proto.proto.CardFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CardFilter;
  return proto.proto.CardFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CardFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CardFilter}
 */
proto.proto.CardFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardTypeName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeFullname(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCardPubliced(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CardFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CardFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CardFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CardFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCardName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCardTypeName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCategoryName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCityName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSbeName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSbeFullname();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCardPubliced();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional int64 card_id = 1;
 * @return {number}
 */
proto.proto.CardFilter.prototype.getCardId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setCardId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string card_name = 2;
 * @return {string}
 */
proto.proto.CardFilter.prototype.getCardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setCardName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string card_type_name = 3;
 * @return {string}
 */
proto.proto.CardFilter.prototype.getCardTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setCardTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string category_name = 4;
 * @return {string}
 */
proto.proto.CardFilter.prototype.getCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city_name = 5;
 * @return {string}
 */
proto.proto.CardFilter.prototype.getCityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setCityName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string sbe_name = 6;
 * @return {string}
 */
proto.proto.CardFilter.prototype.getSbeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setSbeName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string sbe_fullname = 7;
 * @return {string}
 */
proto.proto.CardFilter.prototype.getSbeFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setSbeFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool card_publiced = 8;
 * @return {boolean}
 */
proto.proto.CardFilter.prototype.getCardPubliced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.CardFilter} returns this
 */
proto.proto.CardFilter.prototype.setCardPubliced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CardSort.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CardSort.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CardSort} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CardSort.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    exp: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CardSort}
 */
proto.proto.CardSort.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CardSort;
  return proto.proto.CardSort.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CardSort} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CardSort}
 */
proto.proto.CardSort.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CardSort.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CardSort.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CardSort} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CardSort.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.proto.CardSort.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardSort} returns this
 */
proto.proto.CardSort.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string exp = 2;
 * @return {string}
 */
proto.proto.CardSort.prototype.getExp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CardSort} returns this
 */
proto.proto.CardSort.prototype.setExp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CardPagination.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CardPagination.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CardPagination} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CardPagination.toObject = function(includeInstance, msg) {
  var f, obj = {
    page: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pages: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CardPagination}
 */
proto.proto.CardPagination.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CardPagination;
  return proto.proto.CardPagination.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CardPagination} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CardPagination}
 */
proto.proto.CardPagination.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPage(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CardPagination.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CardPagination.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CardPagination} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CardPagination.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getPages();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 page = 1;
 * @return {number}
 */
proto.proto.CardPagination.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CardPagination} returns this
 */
proto.proto.CardPagination.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 limit = 2;
 * @return {number}
 */
proto.proto.CardPagination.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CardPagination} returns this
 */
proto.proto.CardPagination.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 pages = 3;
 * @return {number}
 */
proto.proto.CardPagination.prototype.getPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CardPagination} returns this
 */
proto.proto.CardPagination.prototype.setPages = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ListCardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ListCardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ListCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListCardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && proto.proto.CardFilter.toObject(includeInstance, f),
    sort: (f = msg.getSort()) && proto.proto.CardSort.toObject(includeInstance, f),
    pagination: (f = msg.getPagination()) && proto.proto.CardPagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ListCardRequest}
 */
proto.proto.ListCardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ListCardRequest;
  return proto.proto.ListCardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ListCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ListCardRequest}
 */
proto.proto.ListCardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.CardFilter;
      reader.readMessage(value,proto.proto.CardFilter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    case 2:
      var value = new proto.proto.CardSort;
      reader.readMessage(value,proto.proto.CardSort.deserializeBinaryFromReader);
      msg.setSort(value);
      break;
    case 3:
      var value = new proto.proto.CardPagination;
      reader.readMessage(value,proto.proto.CardPagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ListCardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ListCardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ListCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListCardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.CardFilter.serializeBinaryToWriter
    );
  }
  f = message.getSort();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.CardSort.serializeBinaryToWriter
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.CardPagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional CardFilter filter = 1;
 * @return {?proto.proto.CardFilter}
 */
proto.proto.ListCardRequest.prototype.getFilter = function() {
  return /** @type{?proto.proto.CardFilter} */ (
    jspb.Message.getWrapperField(this, proto.proto.CardFilter, 1));
};


/**
 * @param {?proto.proto.CardFilter|undefined} value
 * @return {!proto.proto.ListCardRequest} returns this
*/
proto.proto.ListCardRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ListCardRequest} returns this
 */
proto.proto.ListCardRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ListCardRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CardSort sort = 2;
 * @return {?proto.proto.CardSort}
 */
proto.proto.ListCardRequest.prototype.getSort = function() {
  return /** @type{?proto.proto.CardSort} */ (
    jspb.Message.getWrapperField(this, proto.proto.CardSort, 2));
};


/**
 * @param {?proto.proto.CardSort|undefined} value
 * @return {!proto.proto.ListCardRequest} returns this
*/
proto.proto.ListCardRequest.prototype.setSort = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ListCardRequest} returns this
 */
proto.proto.ListCardRequest.prototype.clearSort = function() {
  return this.setSort(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ListCardRequest.prototype.hasSort = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CardPagination pagination = 3;
 * @return {?proto.proto.CardPagination}
 */
proto.proto.ListCardRequest.prototype.getPagination = function() {
  return /** @type{?proto.proto.CardPagination} */ (
    jspb.Message.getWrapperField(this, proto.proto.CardPagination, 3));
};


/**
 * @param {?proto.proto.CardPagination|undefined} value
 * @return {!proto.proto.ListCardRequest} returns this
*/
proto.proto.ListCardRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ListCardRequest} returns this
 */
proto.proto.ListCardRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ListCardRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.ListCardResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ListCardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ListCardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ListCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListCardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.proto.Card.toObject, includeInstance),
    params: (f = msg.getParams()) && proto.proto.ListCardRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ListCardResponse}
 */
proto.proto.ListCardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ListCardResponse;
  return proto.proto.ListCardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ListCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ListCardResponse}
 */
proto.proto.ListCardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Card;
      reader.readMessage(value,proto.proto.Card.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    case 2:
      var value = new proto.proto.ListCardRequest;
      reader.readMessage(value,proto.proto.ListCardRequest.deserializeBinaryFromReader);
      msg.setParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ListCardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ListCardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ListCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ListCardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.Card.serializeBinaryToWriter
    );
  }
  f = message.getParams();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.ListCardRequest.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Card items = 1;
 * @return {!Array<!proto.proto.Card>}
 */
proto.proto.ListCardResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.proto.Card>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.Card, 1));
};


/**
 * @param {!Array<!proto.proto.Card>} value
 * @return {!proto.proto.ListCardResponse} returns this
*/
proto.proto.ListCardResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.Card=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.Card}
 */
proto.proto.ListCardResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.Card, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.ListCardResponse} returns this
 */
proto.proto.ListCardResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};


/**
 * optional ListCardRequest params = 2;
 * @return {?proto.proto.ListCardRequest}
 */
proto.proto.ListCardResponse.prototype.getParams = function() {
  return /** @type{?proto.proto.ListCardRequest} */ (
    jspb.Message.getWrapperField(this, proto.proto.ListCardRequest, 2));
};


/**
 * @param {?proto.proto.ListCardRequest|undefined} value
 * @return {!proto.proto.ListCardResponse} returns this
*/
proto.proto.ListCardResponse.prototype.setParams = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ListCardResponse} returns this
 */
proto.proto.ListCardResponse.prototype.clearParams = function() {
  return this.setParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ListCardResponse.prototype.hasParams = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ItemCardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ItemCardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ItemCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ItemCardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && proto.proto.CardFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ItemCardRequest}
 */
proto.proto.ItemCardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ItemCardRequest;
  return proto.proto.ItemCardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ItemCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ItemCardRequest}
 */
proto.proto.ItemCardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.CardFilter;
      reader.readMessage(value,proto.proto.CardFilter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ItemCardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ItemCardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ItemCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ItemCardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.CardFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional CardFilter filter = 1;
 * @return {?proto.proto.CardFilter}
 */
proto.proto.ItemCardRequest.prototype.getFilter = function() {
  return /** @type{?proto.proto.CardFilter} */ (
    jspb.Message.getWrapperField(this, proto.proto.CardFilter, 1));
};


/**
 * @param {?proto.proto.CardFilter|undefined} value
 * @return {!proto.proto.ItemCardRequest} returns this
*/
proto.proto.ItemCardRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ItemCardRequest} returns this
 */
proto.proto.ItemCardRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ItemCardRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.ItemCardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.ItemCardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.ItemCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ItemCardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && proto.proto.Card.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.ItemCardResponse}
 */
proto.proto.ItemCardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.ItemCardResponse;
  return proto.proto.ItemCardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.ItemCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.ItemCardResponse}
 */
proto.proto.ItemCardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.Card;
      reader.readMessage(value,proto.proto.Card.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.ItemCardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.ItemCardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.ItemCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.ItemCardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.Card.serializeBinaryToWriter
    );
  }
};


/**
 * optional Card item = 1;
 * @return {?proto.proto.Card}
 */
proto.proto.ItemCardResponse.prototype.getItem = function() {
  return /** @type{?proto.proto.Card} */ (
    jspb.Message.getWrapperField(this, proto.proto.Card, 1));
};


/**
 * @param {?proto.proto.Card|undefined} value
 * @return {!proto.proto.ItemCardResponse} returns this
*/
proto.proto.ItemCardResponse.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.ItemCardResponse} returns this
 */
proto.proto.ItemCardResponse.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.ItemCardResponse.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CreateCardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CreateCardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CreateCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CreateCardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cardDesc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cardInfo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cardImg: jspb.Message.getFieldWithDefault(msg, 5, ""),
    cardPriority: jspb.Message.getFieldWithDefault(msg, 6, 0),
    cardPubliced: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    cardPromoted: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    typeId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    typeName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    categoryId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    categoryName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    cityId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    cityName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    sbeId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    sbeFullname: jspb.Message.getFieldWithDefault(msg, 16, ""),
    sbeName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    buttonText: jspb.Message.getFieldWithDefault(msg, 18, ""),
    offerUrl: jspb.Message.getFieldWithDefault(msg, 19, ""),
    promotedImg: jspb.Message.getFieldWithDefault(msg, 20, ""),
    dateFrom: (f = msg.getDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTill: (f = msg.getDateTill()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdDate: (f = msg.getCreatedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedDate: (f = msg.getUpdatedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    unlimDate: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    promotedDateFrom: (f = msg.getPromotedDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    promotedDateTill: (f = msg.getPromotedDateTill()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CreateCardRequest}
 */
proto.proto.CreateCardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CreateCardRequest;
  return proto.proto.CreateCardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CreateCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CreateCardRequest}
 */
proto.proto.CreateCardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardDesc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardInfo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardImg(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardPriority(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCardPubliced(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCardPromoted(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTypeId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeName(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCategoryId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCityId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityName(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSbeId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeFullname(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setButtonText(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOfferUrl(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromotedImg(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateFrom(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTill(value);
      break;
    case 23:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedDate(value);
      break;
    case 24:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedDate(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnlimDate(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPromotedDateFrom(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPromotedDateTill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CreateCardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CreateCardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CreateCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CreateCardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCardDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCardInfo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCardImg();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCardPriority();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCardPubliced();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCardPromoted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getTypeId();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getTypeName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCategoryId();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCategoryName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCityId();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getCityName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSbeId();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getSbeFullname();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSbeName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getButtonText();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOfferUrl();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getPromotedImg();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getDateFrom();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTill();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedDate();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedDate();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnlimDate();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getPromotedDateFrom();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPromotedDateTill();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string card_name = 2;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getCardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCardName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string card_desc = 3;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getCardDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCardDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string card_info = 4;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getCardInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCardInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string card_img = 5;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getCardImg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCardImg = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 card_priority = 6;
 * @return {number}
 */
proto.proto.CreateCardRequest.prototype.getCardPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCardPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool card_publiced = 7;
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.getCardPubliced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCardPubliced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool card_promoted = 8;
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.getCardPromoted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCardPromoted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 type_id = 9;
 * @return {number}
 */
proto.proto.CreateCardRequest.prototype.getTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string type_name = 10;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 category_id = 11;
 * @return {number}
 */
proto.proto.CreateCardRequest.prototype.getCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string category_name = 12;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 city_id = 13;
 * @return {number}
 */
proto.proto.CreateCardRequest.prototype.getCityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCityId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string city_name = 14;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getCityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setCityName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 sbe_id = 15;
 * @return {number}
 */
proto.proto.CreateCardRequest.prototype.getSbeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setSbeId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string sbe_fullname = 16;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getSbeFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setSbeFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string sbe_name = 17;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getSbeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setSbeName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string button_text = 18;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getButtonText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setButtonText = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string offer_url = 19;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getOfferUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setOfferUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string promoted_img = 20;
 * @return {string}
 */
proto.proto.CreateCardRequest.prototype.getPromotedImg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setPromotedImg = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional google.protobuf.Timestamp date_from = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.CreateCardRequest.prototype.getDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.CreateCardRequest} returns this
*/
proto.proto.CreateCardRequest.prototype.setDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.clearDateFrom = function() {
  return this.setDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.hasDateFrom = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.Timestamp date_till = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.CreateCardRequest.prototype.getDateTill = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.CreateCardRequest} returns this
*/
proto.proto.CreateCardRequest.prototype.setDateTill = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.clearDateTill = function() {
  return this.setDateTill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.hasDateTill = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Timestamp created_date = 23;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.CreateCardRequest.prototype.getCreatedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 23));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.CreateCardRequest} returns this
*/
proto.proto.CreateCardRequest.prototype.setCreatedDate = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.clearCreatedDate = function() {
  return this.setCreatedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.hasCreatedDate = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Timestamp updated_date = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.CreateCardRequest.prototype.getUpdatedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.CreateCardRequest} returns this
*/
proto.proto.CreateCardRequest.prototype.setUpdatedDate = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.clearUpdatedDate = function() {
  return this.setUpdatedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.hasUpdatedDate = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional bool unlim_date = 25;
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.getUnlimDate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.setUnlimDate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional google.protobuf.Timestamp promoted_date_from = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.CreateCardRequest.prototype.getPromotedDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.CreateCardRequest} returns this
*/
proto.proto.CreateCardRequest.prototype.setPromotedDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.clearPromotedDateFrom = function() {
  return this.setPromotedDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.hasPromotedDateFrom = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp promoted_date_till = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.CreateCardRequest.prototype.getPromotedDateTill = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.CreateCardRequest} returns this
*/
proto.proto.CreateCardRequest.prototype.setPromotedDateTill = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.CreateCardRequest} returns this
 */
proto.proto.CreateCardRequest.prototype.clearPromotedDateTill = function() {
  return this.setPromotedDateTill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.CreateCardRequest.prototype.hasPromotedDateTill = function() {
  return jspb.Message.getField(this, 27) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.CreateCardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.CreateCardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.CreateCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CreateCardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardName: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.CreateCardResponse}
 */
proto.proto.CreateCardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.CreateCardResponse;
  return proto.proto.CreateCardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.CreateCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.CreateCardResponse}
 */
proto.proto.CreateCardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.CreateCardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.CreateCardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.CreateCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.CreateCardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string card_name = 1;
 * @return {string}
 */
proto.proto.CreateCardResponse.prototype.getCardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.CreateCardResponse} returns this
 */
proto.proto.CreateCardResponse.prototype.setCardName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.UpdateCardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.UpdateCardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.UpdateCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.UpdateCardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cardName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    cardDesc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cardInfo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cardImg: jspb.Message.getFieldWithDefault(msg, 5, ""),
    cardPriority: jspb.Message.getFieldWithDefault(msg, 6, 0),
    cardPubliced: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    cardPromoted: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    typeId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    typeName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    categoryId: jspb.Message.getFieldWithDefault(msg, 11, 0),
    categoryName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    cityId: jspb.Message.getFieldWithDefault(msg, 13, 0),
    cityName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    sbeId: jspb.Message.getFieldWithDefault(msg, 15, 0),
    sbeFullname: jspb.Message.getFieldWithDefault(msg, 16, ""),
    sbeName: jspb.Message.getFieldWithDefault(msg, 17, ""),
    buttonText: jspb.Message.getFieldWithDefault(msg, 18, ""),
    offerUrl: jspb.Message.getFieldWithDefault(msg, 19, ""),
    promotedImg: jspb.Message.getFieldWithDefault(msg, 20, ""),
    dateFrom: (f = msg.getDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    dateTill: (f = msg.getDateTill()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdDate: (f = msg.getCreatedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedDate: (f = msg.getUpdatedDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    unlimDate: jspb.Message.getBooleanFieldWithDefault(msg, 25, false),
    promotedDateFrom: (f = msg.getPromotedDateFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    promotedDateTill: (f = msg.getPromotedDateTill()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.UpdateCardRequest}
 */
proto.proto.UpdateCardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.UpdateCardRequest;
  return proto.proto.UpdateCardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.UpdateCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.UpdateCardRequest}
 */
proto.proto.UpdateCardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardDesc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardInfo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardImg(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardPriority(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCardPubliced(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCardPromoted(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTypeId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeName(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCategoryId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategoryName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCityId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCityName(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSbeId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeFullname(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSbeName(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setButtonText(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOfferUrl(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromotedImg(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateFrom(value);
      break;
    case 22:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDateTill(value);
      break;
    case 23:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedDate(value);
      break;
    case 24:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedDate(value);
      break;
    case 25:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnlimDate(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPromotedDateFrom(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPromotedDateTill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.UpdateCardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.UpdateCardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.UpdateCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.UpdateCardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getCardName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCardDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCardInfo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCardImg();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCardPriority();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getCardPubliced();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCardPromoted();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getTypeId();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getTypeName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCategoryId();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getCategoryName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCityId();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getCityName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSbeId();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getSbeFullname();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSbeName();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getButtonText();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOfferUrl();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getPromotedImg();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getDateFrom();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDateTill();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedDate();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedDate();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnlimDate();
  if (f) {
    writer.writeBool(
      25,
      f
    );
  }
  f = message.getPromotedDateFrom();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPromotedDateTill();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 card_id = 1;
 * @return {number}
 */
proto.proto.UpdateCardRequest.prototype.getCardId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string card_name = 2;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getCardName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string card_desc = 3;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getCardDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string card_info = 4;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getCardInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string card_img = 5;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getCardImg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardImg = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 card_priority = 6;
 * @return {number}
 */
proto.proto.UpdateCardRequest.prototype.getCardPriority = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardPriority = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool card_publiced = 7;
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.getCardPubliced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardPubliced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool card_promoted = 8;
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.getCardPromoted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCardPromoted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional int64 type_id = 9;
 * @return {number}
 */
proto.proto.UpdateCardRequest.prototype.getTypeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setTypeId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional string type_name = 10;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 category_id = 11;
 * @return {number}
 */
proto.proto.UpdateCardRequest.prototype.getCategoryId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCategoryId = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string category_name = 12;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getCategoryName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCategoryName = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional int64 city_id = 13;
 * @return {number}
 */
proto.proto.UpdateCardRequest.prototype.getCityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCityId = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string city_name = 14;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getCityName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setCityName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional int64 sbe_id = 15;
 * @return {number}
 */
proto.proto.UpdateCardRequest.prototype.getSbeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setSbeId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string sbe_fullname = 16;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getSbeFullname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setSbeFullname = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string sbe_name = 17;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getSbeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setSbeName = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string button_text = 18;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getButtonText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setButtonText = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string offer_url = 19;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getOfferUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setOfferUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string promoted_img = 20;
 * @return {string}
 */
proto.proto.UpdateCardRequest.prototype.getPromotedImg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setPromotedImg = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional google.protobuf.Timestamp date_from = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.UpdateCardRequest.prototype.getDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.UpdateCardRequest} returns this
*/
proto.proto.UpdateCardRequest.prototype.setDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.clearDateFrom = function() {
  return this.setDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.hasDateFrom = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional google.protobuf.Timestamp date_till = 22;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.UpdateCardRequest.prototype.getDateTill = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 22));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.UpdateCardRequest} returns this
*/
proto.proto.UpdateCardRequest.prototype.setDateTill = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.clearDateTill = function() {
  return this.setDateTill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.hasDateTill = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Timestamp created_date = 23;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.UpdateCardRequest.prototype.getCreatedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 23));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.UpdateCardRequest} returns this
*/
proto.proto.UpdateCardRequest.prototype.setCreatedDate = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.clearCreatedDate = function() {
  return this.setCreatedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.hasCreatedDate = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Timestamp updated_date = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.UpdateCardRequest.prototype.getUpdatedDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.UpdateCardRequest} returns this
*/
proto.proto.UpdateCardRequest.prototype.setUpdatedDate = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.clearUpdatedDate = function() {
  return this.setUpdatedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.hasUpdatedDate = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional bool unlim_date = 25;
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.getUnlimDate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 25, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.setUnlimDate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 25, value);
};


/**
 * optional google.protobuf.Timestamp promoted_date_from = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.UpdateCardRequest.prototype.getPromotedDateFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.UpdateCardRequest} returns this
*/
proto.proto.UpdateCardRequest.prototype.setPromotedDateFrom = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.clearPromotedDateFrom = function() {
  return this.setPromotedDateFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.hasPromotedDateFrom = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp promoted_date_till = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.UpdateCardRequest.prototype.getPromotedDateTill = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.UpdateCardRequest} returns this
*/
proto.proto.UpdateCardRequest.prototype.setPromotedDateTill = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.UpdateCardRequest} returns this
 */
proto.proto.UpdateCardRequest.prototype.clearPromotedDateTill = function() {
  return this.setPromotedDateTill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.UpdateCardRequest.prototype.hasPromotedDateTill = function() {
  return jspb.Message.getField(this, 27) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.UpdateCardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.UpdateCardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.UpdateCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.UpdateCardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.UpdateCardResponse}
 */
proto.proto.UpdateCardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.UpdateCardResponse;
  return proto.proto.UpdateCardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.UpdateCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.UpdateCardResponse}
 */
proto.proto.UpdateCardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.UpdateCardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.UpdateCardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.UpdateCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.UpdateCardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 card_id = 1;
 * @return {number}
 */
proto.proto.UpdateCardResponse.prototype.getCardId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.UpdateCardResponse} returns this
 */
proto.proto.UpdateCardResponse.prototype.setCardId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeleteCardRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeleteCardRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeleteCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeleteCardRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeleteCardRequest}
 */
proto.proto.DeleteCardRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeleteCardRequest;
  return proto.proto.DeleteCardRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeleteCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeleteCardRequest}
 */
proto.proto.DeleteCardRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeleteCardRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeleteCardRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeleteCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeleteCardRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 card_id = 1;
 * @return {number}
 */
proto.proto.DeleteCardRequest.prototype.getCardId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeleteCardRequest} returns this
 */
proto.proto.DeleteCardRequest.prototype.setCardId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.DeleteCardResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.DeleteCardResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.DeleteCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeleteCardResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    cardId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.DeleteCardResponse}
 */
proto.proto.DeleteCardResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.DeleteCardResponse;
  return proto.proto.DeleteCardResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.DeleteCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.DeleteCardResponse}
 */
proto.proto.DeleteCardResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCardId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.DeleteCardResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.DeleteCardResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.DeleteCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.DeleteCardResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCardId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 card_id = 1;
 * @return {number}
 */
proto.proto.DeleteCardResponse.prototype.getCardId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.DeleteCardResponse} returns this
 */
proto.proto.DeleteCardResponse.prototype.setCardId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


goog.object.extend(exports, proto.proto);

module.exports = proto.proto;